import { RadioButtonGroup } from 'commons/components';
import { InterfaceNameBooleanValue } from 'commons/types';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import { RadioOptionsSkeleton } from '../RadioOptionsSkeleton';

interface StatusProps {
  value: boolean;
  onChange: ({ value, name }: InterfaceNameBooleanValue) => void;
}

export function Active({ value, onChange }: Readonly<StatusProps>) {
  const t = useTranslationMarketing('coupons.couponForm.limits.active');
  return (
    <RadioButtonGroup
      label={t('title')}
      boldLabel
      name="active"
      options={[
        {
          label: t('enabled'),
          value: 'enabled',
        },
        {
          label: t('disabled'),
          value: 'disabled',
        },
      ]}
      onChange={({ value }) =>
        onChange({ value: value === 'enabled', name: 'active' })
      }
      value={value ? 'enabled' : 'disabled'}
    />
  );
}

Active.Skeleton = RadioOptionsSkeleton;
